import React from "react";
import { ReactComponent as FstyrLogo } from "../../../resources/logos/fstyr-logo.svg";

export function Logo() {
    return (
        <div>
            <FstyrLogo />
        </div>
    );
}
